const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Vr24 = function Vr24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#00be28",
        fillOpacity: "1",
      },
      d: "M24 24H3.691A3.691 3.691 0 0 1 0 20.309V0h20.309A3.691 3.691 0 0 1 24 3.691Zm0 0",
    }),
    /*#__PURE__*/ React.createElement("path", {
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fff",
        fillOpacity: "1",
      },
      d: "M11.156 18.332H6.648c-.82 0-1.293-.348-1.59-1.105l-2.83-7.278h3.035c.816 0 1.312.36 1.574 1.13l1.258 3.702h.496l2.816-7.754h5.442c2.683 0 4.172 1.27 4.172 3.54 0 1.23-.61 2.25-1.727 2.87.16.325.36.793.66 1.586.809 2.137 1.29 2.797 1.8 3.305h-2.87c-1.29 0-2.074-.57-2.547-1.8l-1.75-4.606c.21.047.469.062.719.062 1.078 0 1.675-.37 1.675-1.054 0-.66-.484-.98-1.48-.98h-1.14Zm0 0",
    })
  );
};
Vr24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
};
var Vr32 = function Vr32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      width: "32",
      height: "24",
      rx: "4",
      fill: "#00A413",
    }),
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      stroke: "#000",
      strokeOpacity: ".15",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M26 18h-5.4l-1.86-6.6h1.33c.27.03 1.3-.35 1.29-1.3 0-.86-.84-.84-1.14-.85h-1.66L14.96 18H9.6L6 8.75h4.41l1.74 4.91L14.22 6h7.9a3.82 3.82 0 0 1 1.9 7.17L26 18Z",
      fill: "#fff",
    })
  );
};
Vr32.defaultProps = {
  width: "32",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Vr24,
  32: Vr32,
};
export function Vr(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Vr' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
